import { CSSObject, AspectRatio } from '@chakra-ui/react'
import { SpringValue } from 'react-spring'

import { AnimatedStack } from '@/lib/springComponent'

interface Props {
  image: string
  poster: string
  style?: Record<string, SpringValue | CSSObject>
  sx?: CSSObject
}

function CarouselItem({ image, poster, style, sx }: Props): React.ReactElement {
  return (
    <>
      <AnimatedStack
        spacing="6"
        layerStyle="container"
        style={style}
        sx={{
          p: { base: 0, md: 0 },
          color: 'black',
          maxW: { base: 'full', md: '50%' },
          '&:first-of-type': { ml: { base: 0, md: '25%' } },
          '*': {
            userSelect: 'none',
            userDrag: 'none',
          },
          ...sx,
        }}
      >
        <AspectRatio
          ratio={824 / 515}
          sx={{
            video: {
              borderRadius: '14px',
              objectFit: 'fill',
            },
          }}
        >
          <video
            width="824px"
            height="515px"
            controls
            poster={poster}
            controlsList="nodownload"
          >
            <source src={image} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </AspectRatio>
      </AnimatedStack>
    </>
  )
}

export default CarouselItem
